<div id="page-login"
    class="site-wrapper">
    <main class="main">
        <div class="page-wrapper">
            <div class="page-content lean">
                <a routerLink="/">
                    <img class="logo"
                        src="/assets/images/logo/logo-teamworks-primary_white.svg"
                        alt="" />
                </a>

                <form [formGroup]="resetPasswordForm"
                    class="login-form"
                    (ngSubmit)="onSubmit()"
                    [attr.data-cy]="dataCySelectors.RESET_PASSWORD_FORM">
                    <mat-form-field class="minimal">
                        <mat-label>{{ 'NEW_PASSWORD.NEW_PASS_PLACEHOLDER' | translate}}</mat-label>
                        <input matInput
                            type="password"
                            formControlName="password"
                            required>
                        <mat-error *ngIf="resetPasswordForm.controls.password.hasError('minlength')"
                            [innerHTML]="'NEW_PASSWORD.LENGTH_ERROR' | translate">
                        </mat-error>
                        <mat-error *ngIf="resetPasswordForm.controls.password.hasError('required')"
                            [innerHTML]="'NEW_PASSWORD.NEW_PASS_ERROR' | translate">
                        </mat-error>
                    </mat-form-field>

                    <mat-form-field class="minimal">
                        <mat-label>{{ 'NEW_PASSWORD.NEW_PASS_CONFIRM_PLACEHOLDER' | translate}}</mat-label>
                        <input matInput
                            type="password"
                            formControlName="confirmPassword"
                            required>
                        <mat-error *ngIf="resetPasswordForm.controls.confirmPassword.hasError('passwordsDontMatch')"
                            [innerHTML]="'NEW_PASSWORD.NEW_PASS_CONFIRM_MATCH_ERROR' | translate">
                        </mat-error>
                        <mat-error *ngIf="resetPasswordForm.controls.confirmPassword.hasError('required')"
                            [innerHTML]="'NEW_PASSWORD.NEW_PASS_CONFIRM_ERROR' | translate">
                        </mat-error>
                    </mat-form-field>

                    <button type="submit"
                        class="btn-login oa-button"
                        [class.loading]="isCreatingNewPassword$ | async"
                        [disabled]="submitDisabled$ | async">{{ 'NEW_PASSWORD.CHANGE_PASSWORD_BUTTON' | translate }}</button>
                </form>

                <div class="error-container">
                    <p class="form-message {{(authStatusMessage$ | async)?.type === 'success' ? 'form-success' : 'form-error'}}">
                        {{(authStatusMessage$ | async)?.message}}
                    </p>

                    <div class="forgot-password">
                        {{ 'LOGIN.FORGOT_PASSWORD' | translate }} <a class="forgot-password__link"
                            [routerLink]="['/forgot-password']">{{ 'LOGIN.FORGOT_PASSWORD_CLICK_HERE' | translate }}.</a>
                    </div>
                </div>
            </div>
        </div>
    </main>
</div>
